module.exports = __webpack_public_path__ + "img/weekend-breakfast-sausage.0ce97ac5.jpg";